module.exports = __webpack_public_path__ + "static/img/Eudoxus_Distribution_Logo_White_Gr.48e9d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Eudoxus_Distribution_Logo_White_Gr.png
// module id = qvO6
// module chunks = 1